import { isPlatformServer } from '@angular/common';
import {
  HttpRequest,
  HTTP_INTERCEPTORS,
  HttpHandler,
  HttpInterceptor,
  HttpResponse,
  HttpEvent
} from '@angular/common/http';
import { inject, Injectable, PLATFORM_ID, Provider } from '@angular/core';
import { Observable, tap } from 'rxjs';

import { INITIAL_SESSION_GUID_TOKEN, provideInitialSessionGuid } from './bootstrap/initial-session-guid';

@Injectable()
export class LoggingInterceptor implements HttpInterceptor {
  private readonly initialSessionGuid = inject(INITIAL_SESSION_GUID_TOKEN);
  private readonly isSSR = isPlatformServer(inject(PLATFORM_ID));
  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<any>> {
    const startTime = Date.now();

    const clonedRequest = req.clone({
      setHeaders: {
        'x-initial-session': this.initialSessionGuid,
        ...(this.isSSR && { 'x-ssr-request': 'true' })
      }
    });
    return next.handle(clonedRequest).pipe(
      tap(event => {
        if (event instanceof HttpResponse) {
          const duration = Date.now() - startTime;
          logToCloudWatch({
            url: req.urlWithParams,
            duration: `${duration}ms`,
            sessionGuid: this.initialSessionGuid,
            status: event.status
          });
        }
      })
    );
  }
}
export function provideAnalyticsInterceptor(): Provider {
  return [
    provideInitialSessionGuid(),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoggingInterceptor,
      multi: true
    }
  ];
}

function logToCloudWatch(message: Record<string, any>): void {
  console.info(JSON.stringify(message)); // Always output structured logs
}
